import axios from 'axios';

import http from '../../../services/http';
import {
  ANCHOR_VIDEOS_ARCHIVE,
  ANCHOR_VIDEOS_ARCHIVE_VIDEO,
} from '../../../constants/apiUrls/apiUrls';
import forResponse from '../../../utils/forResponse';


export const getVideos = ({ id, params }) => {
  const url = ANCHOR_VIDEOS_ARCHIVE.replace('{id}', id);

  return http.get(url, { params });
};

export const getVideo = ({ id, videoId }) => {
  const url = ANCHOR_VIDEOS_ARCHIVE_VIDEO.replace('{id}', id).replace('{videoId}', videoId);

  return http.get(url);
};

export const deleteVideo = ({ id, videoId }) => {
  const url = ANCHOR_VIDEOS_ARCHIVE_VIDEO.replace('{id}', id).replace('{videoId}', videoId);

  return http.delete(url);
};

export const updateVideo = ({ id, videoId, data }) => {
  const url = ANCHOR_VIDEOS_ARCHIVE_VIDEO.replace('{id}', id).replace('{videoId}', videoId);

  return http.put(url, data);
};

export const uploadVideo = ({ id, data, video, onProgress }) => {
  let totalFinishedPercentage = 0;

  return new Promise(async(resolve, reject) => {
    const initialUrl = ANCHOR_VIDEOS_ARCHIVE.replace('{id}', id);
    const response = await forResponse(http.post(
      initialUrl,
      data,
      {
        onUploadProgress: (event) => {
          if (event.loaded === event.total) {
            totalFinishedPercentage = 10;
            onProgress(totalFinishedPercentage);
          }
        },
      }));
    if (response.data) {
      const { videoId, initialUploadUrl } = response.data.data;
      const blankInstance = axios.create();
      const anotherResponse = await forResponse(blankInstance.put(
        initialUploadUrl,
        video,
        {
          onUploadProgress: (event) => {
            totalFinishedPercentage += event.loaded / event.total * 0.85;
            onProgress(totalFinishedPercentage);
          },
        }
      ));
      if (anotherResponse.data) {
        const lastUrl = ANCHOR_VIDEOS_ARCHIVE_VIDEO.replace('{id}', id).replace('{videoId}', videoId);
        const lastResponse = await forResponse(http.put(lastUrl, { anchorId: id, videoId, status: 'UPLOADED' }));
        if (lastResponse.data) {
          onProgress(100);
          setTimeout(() => {
            resolve();
          }, 500);
        } else {
          reject();
        }
      } else {
        reject(response.error);
      }
    } else {
      reject(response.error);
    }
  });
};
